import { useEffect } from "react";
import $ from 'jquery';
import { FaWindowMinimize } from "react-icons/fa6";
// import chat from '../assets/chat.svg'

const SupportChat = () => {
    useEffect(() => {
        // jQuery code to handle the toggle functionality
        $('.buttonChat').on('click', function () {
            $('.mt-chat').show(300);
        });
        $('.minimizeButton').on('click', function () {
            $('.mt-chat').hide(300);
        });
    }, []);
    return (
        // <a href="https://api.whatsapp.com/send?phone=+601163533992&text=hi" target="_blank" rel="noreferrer" className='fixed bottom-5 right-5 z-40'>
        //     <img src={chat} className='w-14 2xl:w-20' alt="chat Support" />
        // </a>
        <>
            <button aria-label="chatIcon" className="buttonChat shrink-0 relative" >
            <h1 className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap text-sm mix-blend-multiply bg-white px-3 rounded-full font-bold text-black">{`Let's Chat!`}</h1>
                <img src="/assets/chat.png" className="size-16 object-contain"  alt="UNITEN Logo" />
                <div className="hovercap">Chat with UVA</div>
            </button>
            <section className="mt-chat" style={{ display: 'none' }}>
                <div className="chat">
                    <div className="chat-title">
                        <button aria-label="minimize" className="minimizeButton">
                            <FaWindowMinimize size={25} />
                        </button>
                        <div className="black">Welcome to UNITEN Virtual Assistance!</div>
                    </div>
                    <hr className="hr-1" />
                    <div className="messages">
                        <iframe
                            src="https://nubidesk4.nubitel.io:7200/Nubibot_Uniten/Chat/ChatLogin.aspx"
                            width="100%"
                            height="500px"
                            style={{ border: 'none' }}
                            title="Chat Frame"
                        ></iframe>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SupportChat